(function ($) {
    $('[data-toggle="tooltip"]').tooltip();
    $('.user-check__content .checkable').before().click(function (event) {

        // links should still work...
        if (!$(event.target).closest('a').length) {
            event.preventDefault();
            var $this = $(this);
            $.post($this.attr('data-route')).then(function () {
                $this.toggleClass('user-check__list_checked');
            });
        }
    });
    $('.user-check__label').click(function (event) {
        event.preventDefault();
        var $this = $(this);
        $('.user-check__label').removeClass('active');
        $this.addClass('active');
        $('.user-check__content').addClass('hidden');
        $('#traveler_' + $this.attr('data-id')).removeClass('hidden');
        window.location.hash = $this.attr('href');
        var collapser = $('.user__arrow');
        if (collapser.attr('aria-expanded') !== 'true') {
            collapser.click();
        }
    });

    $(document).ready(function () {
        let travelerId = window.location.hash;
        if(travelerId) {
            $('.user-check__label[data-id="'+travelerId.replace('#', '') + '"]').click();
        }
    });

    $('.print').click(function (event) {
        event.preventDefault();
        window.open($(this).attr('data-url'));
    });
    $('.download-form').click(function (event) {
        event.stopPropagation();
    });
})(jQuery);

